var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624 2509 c25 -478 28 -611 23 -1004 -3 -236 -11 -565 -18 -730 -7 -165 -13 -336 -14 -380 l0 -80 149 -3 148 -3 -8 173 c-5 95 -9 238 -9 318 l0 145 557 3 558 2 29 -57 c35 -70 155 -351 207 -485 l37 -98 124 0 c68 0 123 4 123 8 0 13 -65 199 -117 336 -114 300 -238 564 -326 696 -69 103 -181 212 -258 251 l-63 31 34 19 c19 10 42 21 50 26 35 17 156 117 177 146 13 17 27 33 32 36 37 25 95 236 84 308 -19 126 -52 203 -107 251 -20 17 -36 36 -36 41 0 5 -8 11 -17 15 -10 3 -47 22 -83 41 -36 19 -73 35 -82 35 -10 0 -18 4 -18 8 0 4 -26 13 -57 20 -32 7 -78 17 -103 23 -27 6 -244 13 -534 16 l-488 5 6 -113z m874 -70 c53 -6 101 -14 107 -19 5 -4 28 -11 50 -15 81 -14 180 -86 217 -159 31 -59 31 -210 0 -277 -41 -88 -177 -197 -277 -223 -11 -2 -38 -12 -60 -20 -22 -8 -57 -15 -77 -16 -20 0 -40 -4 -43 -10 -4 -6 -107 -10 -276 -10 l-269 0 0 380 0 380 265 0 c146 0 309 -5 363 -11z m-32 -963 c89 -10 121 -19 170 -44 102 -55 178 -131 253 -254 l23 -38 -511 0 -511 0 0 175 0 175 233 0 c127 -1 282 -7 343 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.19e9b4c455ea4c47a0bbd17a2ef6a454.svg";
export { ForwardRef as ReactComponent };